var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 287,
    height: 75,
    viewBox: "0 0 287 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jfhs612dka",
    width: "113.4%",
    height: "171.4%",
    x: "-6.7%",
    y: "-35.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.138439685 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "6a0exswbjb",
    width: 261,
    height: 49,
    x: 0,
    y: 0,
    rx: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#jfhs612dka)",
    transform: "translate(-45 -370) translate(58 383)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FEFFFD",
    xlinkHref: "#6a0exswbjb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5A5A5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5V0L3 5l5 5V5.5c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6H0c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8",
    transform: "translate(-45 -370) translate(58 383) rotate(150 123.101 49.127)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5A5A5A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0v7h3l-6 7-6-7h3V0h6zM0 16H16V18H0z",
    transform: "translate(-45 -370) translate(58 383) translate(125 16)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5A5A5A",
    strokeWidth: 2,
    d: "M78 29.5L72.71 32.281 73.72 26.391 69.44 22.219 75.355 21.359 78 16 80.645 21.359 86.56 22.219 82.28 26.391 83.29 32.281z",
    transform: "translate(-45 -370) translate(58 383)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45 -370) translate(58 383) translate(177 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "#5A5A5A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A5A5A",
    d: "M9 10H11V16H9zM9 5H11V7H9z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5A5A5A",
    strokeWidth: 2,
    d: "M22.5 16L30 24.5 22.5 32.5",
    transform: "translate(-45 -370) translate(58 383)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5A5A5A",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M14 24.5L29 24.5",
    transform: "translate(-45 -370) translate(58 383)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.aa037dc0d0f0ca4a7efe7168cab5a0c2.svg";
export { ForwardRef as ReactComponent };